define('server-settings',[], function () {
  if (window.SERVER_SETTINGS) {
    return window.SERVER_SETTINGS;
  }

  return {
    productsUrl: '/api/product',
    productList: '/api/product/productlist',
    productListPdf: '/api/product/Catalogue',
    productLoadUrl: '/api/product',
    productApiUrl: '/api/product',
    hash: '2e1a39d6768e724f0701eb63284e6a5c',
    cartApiUrl: '/cart',
    quickCartApiUrl: '/cart/quickcart',
    largeCartApiUrl: 'cart/largecart',
    cartPriceApiUrl: '/api/cart/totalprice',
    matrixApiUrl: '/api/product/:id/matrix',
    matrixviewApiUrl: '/api/product/:id/matrixview',
    productImagesApiUrl: '/api/product/:id/images',
    /* TODO: Change to https when imagebank goes SSL */
    productImagesApiDownloadUrl: 'https://images.nwgmedia.com/ProductZip.aspx?productId=:id&hash=:hash',
    configPriceApiUrl: '/api/article/:sku/price',
    articleGlobalStock: '/api/article/:sku/stock/global',
    articleStock: '/api/article/:sku/stock',
    articleStockList: '/api/article/stock',
    productPriceApiUrl: '/api/product/:id/price',
    productPriceViewApiUrl: '/api/product/priceview',
    productImageFallbackUrl: '/images/no_image.svg',
    profileApiUrl: '/api/profile',
    profileLogoApiUrl: '/api/profile/logo',
    uploadImageApiUrl: '/api/image/logo',
    sellerCustomersApiUrl: '/api/customers',
    setActingRoleApiUrl: '/api/seller/setactingrole/:id/:name',
    profileValidationApiUrl: '/api/getInfo',
    quickAddApiUrl: '/api/product/:sku/verifyquickadd',
    quickAddListApiUrl: '/api/product/verifyquickadd',

    offerApiUrl: '/offer',
    offerListApiUrl: '/api/offer',
    offerDeleteApiUrl: '/api/offer/:id',

    draftDeleteApiUrl: '/api/draft/:id',
    draftApiUrl: '/api/draft',

    wishListApiUrl: '/api/wishlist',
    wishListProductsApiUrl: '/api/wishlist/productslist',
    wishListAddApiUrl: '/api/wishlist/addProduct/?sku=:sku',
    wishListDeleteApiUrl: '/api/wishlist/removeProduct/:sku',

    userImportCheckUserExistApiUrl: '/api/userimport/usernotexist?username=:username',

    businessPartnerUrl: '/api/customer/cid=:cid',

    removeActingRoleApiUrl: '/api/seller/removeactingrole',

    newsListApiUrl: '/api/b2b/news',

    orderApiUrl: '/api/order',
    orderListApiUrl: '/api/order/header',

    applicateMyLogos: '/api/profile/uploadedlogos',

    cartPageUrl: '/cart.html',
    logoLinkUrl: '/logoapp.html?&articleID=:sku',

    processOptionsUrl: '/cart',
    getprocessOptionsUrl: '/cart/getprocessOptions',

    microshop: '/microshop',

    templates: {
      alertBox: '/templates/alert-box.html',
      magnifyImageBox: '/templates/magnify-image-box.html',
      orderMatrix: '/templates/order-matrix.html',
      orderMatrixReplace: '/templates/order-matrix-replace.html',
      globalStock: '/templates/globalstock-view.html',
      applicatelogos: '/templates/applicatelogos-view.html',
      newOfferForm: '/templates/create-offer.html',
      stockQtyWarning: '/templates/stock-qty-warning.html',
    },

    user: {
      username: 'Otto otto',
      hasRole: true,
      isSeller: true,
      allowedToViewStock: true,
    },

    exceedAvailableStockWarningEnabled: false,
  };
});

